import { Application, Feature } from '@frontend/functionality/types';
import { findPlatformFunctionality } from '@frontend/functionality/utils';
import { ModalType, useModals } from '@frontend/modal';
import { ExtendedOrder, OrderStatusName } from '@frontend/order/types';
import { ProductType } from '@frontend/product/types';
import { useAccountRepository, useLicenseRepository } from '@frontend/repository';
import { useMemo } from 'react';

import { WizardModal, wizardModalPaneClassName } from '../../../../wizard-rendering/wizard-modal/wizard-modal.component';

export const useOrderDetailModal = () => {
    const { currentAccount } = useAccountRepository();
    const { functionalities } = useLicenseRepository();
    const { openModal } = useModals();
    const functionality = useMemo(() => findPlatformFunctionality(functionalities, Application.PUDO, Feature.ORDER_TRANSACTION), [functionalities]);

    const canConvert = (order: ExtendedOrder) =>
        order.state === OrderStatusName.PENDING &&
        (order.product?.data?.type === ProductType.CONSUMABLE || order.product?.data?.type === ProductType.EQUIPMENT) &&
        !!functionality?.wizard_id;

    const convertOrder = (order: ExtendedOrder) => {
        const wizardId = functionality?.wizard_id;
        if (!functionality || !wizardId) return;

        openModal(
            `shop-order-convert-${order.id}`,
            () => (
                <WizardModal
                    functionality={functionality}
                    wizardId={wizardId}
                    initialData={{ order }}
                />
            ),
            {},
            { type: ModalType.PANE, className: wizardModalPaneClassName }
        );
    };

    return { currentAccount, canConvert, convertOrder };
};
